//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { OpTransmissionType } from './op-transmission-type'
import { OpAlarmGroup } from './op-alarm-group'
import { OpAlarmDef } from './op-alarm-def'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'

export class OpAlarmDefGroup
    implements IOpChangeState
    , IJsonSerializable
    , ICopyable<OpAlarmDefGroup>
{
    // #region Properties

    public idAlarmDef: number
    public idAlarmGroup: number
    public idTransmissionType: number
    public confirmLevel: number
    public confirmTimeout: number

    // #endregion

    // #region Navigation Properties

    public alarmDef: OpAlarmDef
    public alarmGroup: OpAlarmGroup
    public transmissionType: OpTransmissionType

    // #endregion

    // #region Custom Properties

    public oldIdTransmissionType: number

    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpAlarmDefGroup) {
            this.copy(<OpAlarmDefGroup>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion

    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion

    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idAlarmDef = opObj.ID_ALARM_DEF
            this.idAlarmGroup = opObj.ID_ALARM_GROUP
            this.idTransmissionType = opObj.ID_TRANSMISSION_TYPE
            this.confirmLevel = opObj.CONFIRM_LEVEL
            this.confirmTimeout = opObj.CONFIRM_TIMEOUT

            this.alarmDef = opObj._AlarmDef == null ? null : new OpAlarmDef(opObj._AlarmDef)
            this.alarmGroup = opObj._AlarmGroup == null ? null : new OpAlarmGroup(opObj._AlarmGroup)
            this.transmissionType = opObj._TransmissionType == null ? null : new OpTransmissionType(opObj._TransmissionType)

            this.opState = opObj.OpState
            this.oldIdTransmissionType = opObj.OldIdTransmissionType
        } else {
            this.idAlarmDef = 0
            this.idAlarmGroup = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_DEF: this.idAlarmDef,
            ID_ALARM_GROUP: this.idAlarmGroup,
            ID_TRANSMISSION_TYPE: this.idTransmissionType,
            CONFIRM_LEVEL: this.confirmLevel,
            CONFIRM_TIMEOUT: this.confirmTimeout,

            _AlarmDef: this.alarmDef == null ? null : this.alarmDef.toJSON(),
            _AlarmGroup: this.alarmGroup == null ? null : this.alarmGroup.toJSON(),
            _TransmissionType: this.transmissionType == null ? null : this.transmissionType.toJSON(),

            OpState: this.opState,
            OldIdTransmissionType: this.oldIdTransmissionType
        }
    }

    // #endregion

    // #region ICopyable

    public copy(sourceObject: OpAlarmDefGroup, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (sourceObject == null) {
            return null;
        }

        if (includeNavigationProperties) {
            // alarmDef umyslnie nie klonujemy by uniknąć SO
            this.alarmGroup = sourceObject.alarmGroup == null ? null : sourceObject.alarmGroup.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            //this.transmissionType = sourceObject.transmissionType == null ? null : sourceObject.transmissionType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            this.transmissionType = sourceObject.transmissionType
        }

        if (includeCustomProperties) {
            this.oldIdTransmissionType = sourceObject.oldIdTransmissionType
        }

        if (includeDataList) {

        }

        if (includeDynamicValues) {

        }

        this.idAlarmDef = sourceObject.idAlarmDef
        this.idAlarmGroup = sourceObject.idAlarmGroup
        this.idTransmissionType = sourceObject.idTransmissionType
        this.confirmLevel = sourceObject.confirmLevel
        this.confirmTimeout = sourceObject.confirmTimeout

        this.opState = sourceObject.opState
    }

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpAlarmDefGroup {
        const group: OpAlarmDefGroup = new OpAlarmDefGroup(null)

        group.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return group
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpAlarmDefGroup[]): JQueryPromise<OpAlarmDefGroup[]> {
        const defered: JQueryDeferred<OpAlarmDefGroup[]> = $.Deferred<OpAlarmDefGroup[]>()

        defered.resolve(list)

        return defered.promise()
    }
}
